import { render, staticRenderFns } from "./WarrantyForm.vue?vue&type=template&id=89bc1184&scoped=true&"
import script from "./WarrantyForm.vue?vue&type=script&lang=js&"
export * from "./WarrantyForm.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyForm.vue?vue&type=style&index=0&id=89bc1184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bc1184",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
